import axios from 'axios';
import {
  buildCheckoutQuoteRequest,
  buildCouponValidateRequest,
  normalizeCouponValidateResult,
} from '../../../shared/subscriptionCheckoutLogic';

const PAYMENTS_BASE = '/api/v1/payments';

function extractErrorMessage(error, fallback) {
  const data = error?.response?.data;
  return (
    data?.detail
    || data?.message
    || data?.error
    || (Array.isArray(data?.non_field_errors) ? data.non_field_errors[0] : '')
    || error?.message
    || fallback
  );
}

export async function validateWebsiteSubscriptionCoupon(params) {
  const payload = buildCouponValidateRequest(params);
  try {
    const { data } = await axios.post(`${PAYMENTS_BASE}/coupons/validate/`, payload, {
      withCredentials: true,
    });
    if (!data?.couponApplied) {
      const err = new Error(data?.message || 'Invalid or ineligible coupon code.');
      err.response = { data };
      throw err;
    }
    return {
      ...data,
      details: normalizeCouponValidateResult(data, payload.couponCode),
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Unable to validate coupon right now.');
    const wrapped = new Error(message);
    wrapped.cause = error;
    throw wrapped;
  }
}

export async function fetchWebsiteSubscriptionQuote(params) {
  const payload = buildCheckoutQuoteRequest(params);
  try {
    const { data } = await axios.post(`${PAYMENTS_BASE}/checkout/quote/`, payload, {
      withCredentials: true,
    });
    return data;
  } catch (error) {
    const message = extractErrorMessage(error, 'Unable to load checkout quote.');
    const wrapped = new Error(message);
    wrapped.cause = error;
    throw wrapped;
  }
}

export {
  buildAddonsPayload,
  buildCouponContextSignature,
  buildOrderCouponFields,
  createEmptyCouponDetails,
  normalizeCouponCode,
  resolveCheckoutDisplayTotal,
  resolveCheckoutSavingsMajor,
  toApiBillingInterval,
} from '../../../shared/subscriptionCheckoutLogic';
